/**
 * A type that converts an object type T into a union of its key-value tuples.
 */
type Entries<T> = {
  [K in keyof T]: [key: K, value: T[K]];
}[keyof T][];

/**
 * A strongly-typed wrappers for Object.[entries / keys / values].
 */
export const objectEntriesTyped = <T extends object>(obj: T): Entries<T> =>
  Object.entries(obj) as Entries<T>;

export const objectKeysTyped = <T extends object>(obj: T) =>
  Object.keys(obj) as Array<keyof T>;

export const objectValuesTyped = <T extends object>(obj: T) =>
  Object.values(obj) as Array<T[keyof T]>;
